import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Dayjs } from "utils/dayjs"

import NoValue from "components/NoValue/NoValue"
import { ErpInvoiceStatus } from "models/OutgoingInvoice"
import ErpValue from "./ErpValue"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

interface IErpInvoiceNumberProps {
    invoiceNumber?: string | null
    invoiceDate?: Dayjs | null
    invoiceNumberStatus?: ErpInvoiceStatus
    isInvoiceERPInterfaceConnected?: boolean
    longPending?: boolean
    longError?: boolean
    isItalic?: boolean
    isInvalid?: boolean
    isBold?: boolean
    isRedText?: boolean
}

const ErpInvoiceNumber: FC<IErpInvoiceNumberProps> = ({
    invoiceNumber,
    invoiceDate,
    invoiceNumberStatus,
    isInvoiceERPInterfaceConnected,
    longPending,
    longError,
    isItalic,
    isInvalid,
    isBold,
    isRedText,
}) => {
    const { t } = useTranslation()
    const notApplicable = <NoValue>
        <FlexibleContent text={t("common.notApplicable")} />
    </NoValue>

    if (invoiceNumber) {
        const text = `${invoiceNumber}${invoiceDate ? ` (${invoiceDate.format(t("config.dateLongFormat"))})` : ''}`
        if (isInvalid || isBold) {
            return <ErpValue
                isInvalid={isInvalid}
                isBold={isBold}
                text={text}
            />
        }
        return <div className={isRedText ? "color-red-500" : ""}>{text}</div>
    }

    if (isInvoiceERPInterfaceConnected && !invoiceNumberStatus) {
        return notApplicable
    }

    switch (invoiceNumberStatus) {
        case ErpInvoiceStatus.pending:
            return <ErpValue isInvalid={isInvalid} isItalic={isItalic} text={t(longPending ? "outgoingInvoices.invoiceNumberPending" : "common.pending")} />
        case ErpInvoiceStatus.error:
            return <ErpValue isInvalid isItalic={isItalic} text={longError ? t("outgoingInvoices.retrievingInvoiceNumberFailed") : t("common.failure")} />
        default:
            return notApplicable
    }
}

export default ErpInvoiceNumber
